import { FIELDS } from './constants';

const detailFields = [
  // {
  //   field: 'commands',
  //   title: ' ',
  //   cell: 'commands',
  //   sortable: false,
  //   locked: true,
  //   hidden: false,
  //   width: 40,
  // },
  {
    field: FIELDS.ID,
    title: 'Id',
    hidden: false,
    width: 150,
  },
  {
    field: FIELDS.BILL_PAYMENT_ID,
    title: 'Bill Payment Id',
    hidden: false,
    width: 150,
  },
  {
    field: FIELDS.REFERENCE_ID,
    title: 'Reference Id',
    hidden: false,
    width: 150,
  },
  {
    field: FIELDS.BALANCE,
    title: 'Balance',
    cell: 'formatCurrency',
    hidden: false,
    width: 150,
  },
  {
    field: FIELDS.AMOUNT,
    title: 'Amount',
    cell: 'formatCurrency',
    hidden: false,
    width: 150,
  },
  {
    field: FIELDS.ACTIVE,
    title: 'Active',
    hidden: true,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: true,
    locked: true,
    width: 30,
  },
];

export default detailFields;
